module.exports = __webpack_public_path__ + "static/NotoKufiArabic-61f7e6d74733d17eca228149f99a36b6.woff2";